/**
 * Breakpoints responsivos para a aplicação Kanban
 * Segue abordagem mobile-first
 */

export const breakpoints = {
  mobile: 360,      // 360px - 480px (base)
  mobileLarge: 480, // acima de 480px
  custom724: 724,   // 724px+ (transição de menus)
  tablet: 1120,     // desativado no Kanban (salto para desktop em 1120px)
  laptop: 1120,     // desativado no Kanban (salto para desktop em 1120px)
  desktop: 1120,    // 1120px+ (desktop)
};

/**
 * Media queries predefinidas
 */
export const media = {
  // Mobile first approach
  mobile: `@media (max-width: ${breakpoints.mobileLarge - 1}px)`,
  mobileLarge: `@media (min-width: ${breakpoints.mobileLarge}px)`,
  mobile724: `@media (min-width: ${breakpoints.custom724}px)`,
  tablet: `@media (min-width: ${breakpoints.tablet}px)`,
  tabletOnly: `@media (min-width: 768px) and (max-width: 991px)`,
  laptop: `@media (min-width: ${breakpoints.laptop}px)`,
  laptopOnly: `@media (min-width: ${breakpoints.laptop}px) and (max-width: ${breakpoints.desktop - 1}px)`,
  desktop: `@media (min-width: ${breakpoints.desktop}px)`,
  
  // Utility sizes
  maxWidth: (width: number) => `@media (min-width: ${width}px)`,
  minWidth: (width: number) => `@media (min-width: ${width}px)`,
  maxHeight: (height: number) => `@media (max-height: ${height}px)`,
};

/**
 * Font sizes responsivas
 */
export const fontSizes = {
  mobile: {
    base: '14px',
    sm: '12px',
    md: '16px',
    lg: '18px',
    xl: '20px',
  },
  tablet: {
    base: '15px',
    sm: '13px',
    md: '17px',
    lg: '19px',
    xl: '22px',
  },
  desktop: {
    base: '16px',
    sm: '14px',
    md: '18px',
    lg: '20px',
    xl: '24px',
  },
};

/**
 * Paddings responsivas
 */
export const paddings = {
  mobile: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
  },
  tablet: {
    xs: '6px',
    sm: '12px',
    md: '16px',
    lg: '20px',
    xl: '24px',
  },
  desktop: {
    xs: '8px',
    sm: '16px',
    md: '20px',
    lg: '24px',
    xl: '32px',
  },
};

/**
 * Gaps responsivos
 */
export const gaps = {
  mobile: '0.5rem',
  tablet: '0.75rem',
  desktop: '1rem',
};
